export default {
    cookieName: 'X-INDIA-INFO',
    cookieExpire: 365,
    downloadUrl: "https://s38273883.facepc.net/imgs/Xender-india-Prime.apk" + '?t=' + +new Date()
}